import axios from 'axios'
import store from '../store'
import { getToken ,removeToken} from '@/utils/auth'
import Common from '@/utils/common.js';
import SignRequest from '@/utils/SignRequest'
// 创建axios实例
const service = axios.create({
  baseURL: 'https://api.hutlon.com/api/manager', // api的base_url
  // baseURL: 'http://dianjiang.shenguoyuan.com/api/manager', // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {

  const timeStamp = Date.parse(new Date()) / 1000;

  config.headers['Authorization'] = SignRequest.getToken() ? SignRequest.getToken() : ''; // 让每个请求携带自定义token 请根据实际情况自行修改
  config.headers['Sign'] = SignRequest.getSign(config.url, timeStamp);
  config.headers['MethodName'] =  "api/manager" +config.url;
  config.headers['Content-Type'] = "application/json ; charset=utf-8";
  config.headers['TimeStamp'] = timeStamp;
  return config

}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.Code == '100') {
      // 请求成功
      return response.data
    } else {
      // 请求失败
      Common.showMsg(res.Message);
      return Promise.reject('error')
    }
  },
  error => {
    console.log('err' + error)// for debug
    if (error.response.status === 401) {
      removeToken()
      localStorage.removeItem("beforeLoginUrl");
      localStorage.beforeLoginUrl = window.location.href;
      Common.showMsg('请登录',function(){
        store.dispatch('FedLogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js